import { render } from "./SignPetition.vue?vue&type=template&id=9d4e75d8"
import script from "./SignPetition.vue?vue&type=script&lang=js"
export * from "./SignPetition.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/src/public-poll/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__